import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus, IAnalyticsProduct } from '../../../../../../shared/types/analytics';

interface ITrackPreviewBlockClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  target: 'edit_address_button' | 'edit_address_area';
}

export const trackPreviewBlockClick = (params: ITrackPreviewBlockClickParams) => {
  const { analyticsOfferStatus, analyticsProduct, target } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: target,
    products: [analyticsProduct],
  });
};
